import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {ICartItem} from '../../../../../../../../types/app.types';

export const Price = ({item}: {item: ICartItem}) => {
  const {formattedComparePrice, formattedPrice} = item.convertedPrices;

  return (
    <div className={s.prices}>
      {formattedComparePrice && (
        <span data-hook={CartItemDataHook.ComparePrice} className={s.comparePrice}>
          {formattedComparePrice}
        </span>
      )}
      {formattedPrice && (
        <span data-hook={CartItemDataHook.Price} className={s.price}>
          {formattedPrice}
        </span>
      )}
    </div>
  );
};
